import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled ? "bg-[rgba(4,23,27,0.72)] backdrop-blur-xl border-b border-white/10 py-3" : "py-5 border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button key={n.id} data-testid={`nav-${n.id}`} onClick={() => scrollToId(n.id)} className="link-underline text-sm text-[var(--mist)] hover:text-[var(--foam)] transition-colors">
              {n.label}
            </button>
          ))}
        </nav>
        <button data-testid="header-cta-btn" onClick={() => scrollToId("pool-check")} className="btn-primary text-sm !px-4 sm:!px-6">
          <span className="hidden sm:inline">Pool-Check starten</span>
          <span className="sm:hidden">Pool-Check</span>
          <ArrowUpRight className="h-4 w-4" />
        </button>
      </div>
    </header>
  );
};
